import { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import useStructureSetActivation from '~/hooks/datasetSelection/useStructureSetActivation';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { useReplanningStructureSets } from './useReplanningStructureSets';

export function useSelectPropagatedStructureSet(): void {
    const patient = useSelectedPatient();
    const { propagated } = useReplanningStructureSets();
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const { activateHeld } = useStructureSetActivation();

    const propagatedUid = propagated?.dicomUid;
    const isOnScreen = currentStructureSet?.dicomUid === propagatedUid;
    const handledFor = useRef<string | undefined | null>(null);

    useEffect(() => {
        // Once per propagated set: re-running would undo a set the user chose.
        if (handledFor.current === propagatedUid) {
            return;
        }
        handledFor.current = propagatedUid;
        if (!propagatedUid || isOnScreen) {
            return;
        }
        const set = patient?.structureSets.find(
            (candidate) => candidate.dicomUid === propagatedUid
        );
        if (set) {
            void activateHeld(set);
        }
    }, [propagatedUid, isOnScreen, patient, activateHeld]);
}
